import { IGradeScale, IGradeScaleParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const gradeScaleAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_gradeScale: builder.query<ITableRes<IGradeScale>, IGradeScaleParams>({
      query: (params) => {
        return {
          url: `/grade-scales/`,
          params,
        }
      },
      providesTags: ['grade-scale'],
    }),
    GET_gradeScaleById: builder.query<IGradeScale, string>({
      query: (id) => {
        return {
          url: `/grade-scales/${id}/`,
        }
      },
      providesTags: ['grade-scale-item'],
    }),
    POST_gradeScale: builder.mutation<IGradeScale, IGradeScale>({
      query: (body) => ({
        url: `/grade-scales/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['grade-scale'],
    }),
    PUT_gradeScale: builder.mutation<IGradeScale, { id: string; body: IGradeScale }>({
      query: ({ id, body }) => ({
        url: `/grade-scales/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['grade-scale', 'grade-scale-item'],
    }),
    DELETE_gradeScale: builder.mutation<IGradeScale, string>({
      query: (id) => ({
        url: `/grade-scales/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['grade-scale'],
    }),
  }),
})

export const {
  useGET_gradeScaleQuery,
  usePOST_gradeScaleMutation,
  useGET_gradeScaleByIdQuery,
  usePUT_gradeScaleMutation,
  useDELETE_gradeScaleMutation,
} = gradeScaleAPI
